import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';
import tmsIndentAxiosInstance from '@/tms-indent-axios';

const actions = {
  async getFreightChargeV2({ commit }, { orderId }) {
    try {
      const result = await axios(`/v2/shipper/order/${orderId}/freight_charge`);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getFreightChargeV1({ commit }, { orderId }) {
    try {
      const result = await tmsIndentAxiosInstance(`order/${orderId}/freight_charge`);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
};

export default actions;
